// @TODO dividir esse arquivo
const toggleMenu = () => {
  $('.menu-collapse__submenu').on('click', 'a', e => e.stopPropagation());

  const menu = $('.menu-collapse__item');
  menu.on('click', 'a', function (e) {
    const submenuItem = $(this).parents('.menu-collapse__item');
    const submenu = submenuItem.find('.menu-collapse__submenu');
    const submenuExists = submenu.length === 1;

    if (submenuExists) {
      submenuItem.toggleClass('active');

      if (submenuItem.hasClass('active')) {
        setTimeout(() => {
          submenu.addClass('overflow-animation');
        }, 400);
      } else {
        submenu.removeClass('overflow-animation');
      }

      e.preventDefault();
    }
  });
};

export default toggleMenu;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/common/toggleMenu.js